import { ParsedTechnicalData } from './VehicleTechnicalDataUtils';

export const COMMON_TECHNICAL_DATA_KEYS: (keyof ParsedTechnicalData)[] = [
  'engineDescription',
  'emissionData',
  'ecoRating',
  'emissionFootnotes',
  'fuelType',
  'gearBox',
];

export const MARKET_CONFIGS_DLS: Record<string, (keyof ParsedTechnicalData)[]> = {
  JP: ['fuelType', 'gearBox'],
  VN: ['engineDescription', 'fuelType', 'gearBox'],
  IN: ['engineDescription', 'fuelType', 'gearBox'],
  AU: ['engineDescription', 'fuelType', 'gearBox'],
  MY: ['engineDescription', 'fuelType', 'gearBox'],
  BR: ['engineDescription', 'fuelType', 'gearBox'],
  TH: ['engineDescription', 'fuelType', 'gearBox'],
  DK: ['fuelType', 'gearBox', 'engineDescription'],
  PT: ['fuelType', 'gearBox', 'engineDescription'],
  HU: ['fuelType', 'gearBox', 'engineDescription'],
  AT: ['fuelType', 'gearBox', 'engineDescription'],
  LU: ['fuelType', 'gearBox', 'engineDescription'],
  SK: ['fuelType', 'gearBox', 'engineDescription'],
  DE: ['finalInspectionDate', ...COMMON_TECHNICAL_DATA_KEYS],
};

export const MARKET_CONFIGS_ONE_SEARCH: Record<string, (keyof ParsedTechnicalData)[]> = {
  DK: ['fuelType', 'gearBox', 'engineDescription', 'emissionData', 'emissionFootnotes'],
  DE: ['finalInspectionDate', ...COMMON_TECHNICAL_DATA_KEYS],
  FR: [...COMMON_TECHNICAL_DATA_KEYS],
};
